export enum BaseUrlSegments {
  DetailsForm = 'details',
  EntityID = 'entityId',
  Feed = 'feed',
  ListForm = 'list',
  NewEntity = 'new',
  UnknownEntity = 'unknown',
}
